import React from 'react';
import _ from 'lodash';
import ImagesCell from 'shared-components/ImagesCell/ImagesCell';
import campaignModel from '../../campaignModel';
import { categoryNamesFromIds } from '../../utils';

const TableRow = ({
  row,
  setRowsBeingEdited,
  imagesOpen,
  setImagesOpen,
  categories,
  disableAdminEdit,
}) => {
  const editRow = () => {
    setRowsBeingEdited((prevState) => {
      return {
        ...prevState,
        [row.legacyPostId]: true,
      };
    });
  };
  const { legacyPostId: rowId } = row;
  return (
    <tr key={rowId}>
      {_.map(campaignModel, (col) => {
        const { key } = col;
        switch (key) {
          case 'galleryUrls':
          case 'imageUrl':
            return (
              <td key={key}>
                <ImagesCell
                  images={row[key]}
                  rowId={rowId}
                  type={key}
                  imagesOpen={imagesOpen}
                  openTooltip={() => setImagesOpen(`${rowId}-${key}`)}
                  closeTooltip={() => setImagesOpen(null)}
                />
              </td>
            );
          case 'categoryIds':
            return (
              <td key={key}>
                <div className="row">
                  <p className="row-text">
                    {categoryNamesFromIds(row[key], categories)}
                  </p>
                </div>
              </td>
            );
          case 'productPreviewUrl':
            return (
              <td key={key}>
                <div className="row">
                  <p className="row-link">
                    <a
                      href={row[key]}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {row[key]}
                    </a>
                  </p>
                </div>
              </td>
            );
          default:
            return (
              <td key={key}>
                <div className="row">
                  <p
                    style={
                      key === 'shippingRestrictionsDisplay'
                        ? { textTransform: 'uppercase' }
                        : null
                    }
                    className="row-text"
                  >
                    {row[key]}
                  </p>
                </div>
              </td>
            );
        }
      })}
      <td className="actions-container">
        <button
          className="naked-button"
          type="button"
          disabled={disableAdminEdit}
          onClick={() => editRow()}
        >
          <i className="far fa-edit" />
        </button>
      </td>
    </tr>
  );
};

export default TableRow;
